/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import config from 'linced-app/config/environment';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ApprovalRoute extends Route {
  // Services
  @service
  fetch;

  @service
  store;

  model(params) {
    let id = params.roll_return_id;
    return hash({
      rollReturn: this.store.findRecord('nz-roll-returns/roll-return', id),
      approval: this.fetch.request(
        `${config.APP.apiHost}/providers/nz/moe/v4/rollreturns/rollreturns/${id}/:approvalTables`,
      ),
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
